export const INQUIRY_FORM_SUBMIT_REQUEST = "INQUIRY_FORM_SUBMIT_REQUEST"
export const INQUIRY_FORM_SUBMIT_SUCCESS = "INQUIRY_FORM_SUBMIT_SUCCESS"
export const INQUIRY_FORM_SUBMIT_FAIL = "INQUIRY_FORM_SUBMIT_FAIL"